import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ApplyContextClassModule } from '../../directives/apply-context-class/apply-context-class.module';
import { DropdownModule } from '../../directives/dropdown/dropdown.module';
import { TranslateModule } from '@ngx-translate/core';
import { SearchModule } from '../search/search.module';
import { ShowOnContextModule } from '../../directives/show-on-context/show-on-context.module';
import { ShowForAuthenticatedUserModule } from '../../directives/show-for-authenticated-user/show-for-authenticated-user.module';
import { HideForAuthenticatedUserModule } from '../../directives/hide-for-authenticated-user/hide-for-authenticated-user.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MenuHamburgerModule } from '../menu-hamburger/menu-hamburger.module';

@NgModule({
  declarations: [HeaderComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
    RouterModule,
    ApplyContextClassModule,
    HideForAuthenticatedUserModule,
    ShowForAuthenticatedUserModule,
    ShowOnContextModule,
    DropdownModule,
    TranslateModule,
    SearchModule,
    MatDialogModule,
    MenuHamburgerModule,
  ],
  exports: [HeaderComponent],
})
export class HeaderModule {}
